import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SubscriptionConfirmation from "../SubscriptionConfirmation";
import SubscriptionRequest from '../SubscriptionRequest';
export const SubscriptionRoutes = () => {
  console.log('SubscriptionRoutes');
  return (
    <Routes>
      <Route path="subscription-confirmation/:token" element={<SubscriptionConfirmation />} />
      <Route path="subscription-request" element={<SubscriptionRequest />} />
    </Routes>
  );
}